var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slider-form-group',{attrs:{"label":"Volume","min":0,"max":100,"step":1,"value":_vm.value,"reset-value":100},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.value)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }